import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  // BehaviorSubject holds the current role; default can be 'general'
  private currentRoleSubject = new BehaviorSubject<string>('general');
  currentRole$ = this.currentRoleSubject.asObservable();

  // Call this method to update the current role (for example, after login)
  setRole(role: string): void {
    this.currentRoleSubject.next(role);
    localStorage.setItem('userRole', role);
  }

  // Get the current role
  getRole(): string {
    return this.currentRoleSubject.value;
  }
}
